<template>
    <v-expansion-panels flat tile>
        <v-expansion-panel v-for="(item, index) in items" :key="index">
            <v-expansion-panel-header>
                <v-row align="center" class="row--xs">
                    <v-col cols="auto">
                        <v-avatar :color="legacy ? '#085848' :  'primary'" size="28">
                            <span class="font-size-16 font-weight-bold white--text">Q</span>
                        </v-avatar>
                    </v-col>
                    <v-col>
                        <p class="page-text page-text--lg font-weight-medium grey-1--text">
                            {{ item.Q }}
                        </p>
                    </v-col>
                </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-row align="center" class="row--xs">
                    <v-col cols="auto">
                        <v-avatar :color="legacy ? '#B1972D' : 'grey'" size="28">
                            <span class="font-size-16 font-weight-bold white--text">A</span>
                        </v-avatar>
                    </v-col>
                    <v-col class="page-text page-text--lg" :class="legacy ? 'grey-1--text' : ''">
                        <p v-html="item.A" />
                        <div v-if="item.children" class="mt-12">
                            <v-row v-for="(child, index) in item.children" :key="index" no-gutters>
                                <v-col v-if="child.name" cols="auto">
                                    <strong>{{ child.name }}:&nbsp;</strong>
                                </v-col>
                                <v-col>
                                    {{ child.text }}
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>
                </v-row>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
export default {
    props: {
        items: String,
        legacy: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
.v-expansion-panels {
    border-top: 2px solid #111;
    .v-expansion-panel-header,
    ::v-deep(.v-expansion-panel-content__wrap) {
        padding: 20px 12px;
        border-bottom: 1px solid #ececec;
    }
    .v-expansion-panel-content {
        background-color: #f7f7f7;
    }
}
.v-expansion-panel--active + .v-expansion-panel,
.v-expansion-panel--active:not(:first-child) {
    margin-top: 0;
}
@media (min-width: 768px) {
    .v-expansion-panels {
        .v-expansion-panel-header,
        ::v-deep(.v-expansion-panel-content__wrap) {
            padding: 40px 20px;
        }
        ::v-deep(.v-expansion-panel-content__wrap) {
            padding-left: 60px;
        }
        .v-expansion-panel-content {
            background-color: #f7f7f7;
        }
    }
}
</style>